import Cookies from 'js-cookie';
import $ from 'jquery';

var $modal = $( '[data-modal]' );

if ( $modal.length ) {
  
  $(  window  ).on(  'hashchange', function() {
    updateModal(  location.hash  );
  });

  updateModal(  location.hash  );

  function updateModal( hash ) {
    if (  hash && hash.startsWith( '#!' )  ) {
      if (  hash == '' || hash == '#!'  ) {
        $( 'body' ).removeClass( 'no-scroll' );
      } else {
        $( 'body' ).addClass( 'no-scroll' );
      }
    }

    if (  hash && hash.startsWith( '#!case' ) || hash && hash.startsWith( '#!team' )) {
        $( '.nav' ).hide()
      } else {
        $( '.nav' ).show()
      }
  }

  var serviceVid = document.querySelector( '.introVid' );
  var serviceVid2 = document.querySelector( '.modalVid' );
  var $frame = $( 'iframe#vimeoEmbed' );
  var stop = $( '.servicePlay' );

  // saves the current iframe source
  var vidsrc = $frame.attr( 'src' );


  
  $(  '.servicePause' ).on( 'click', function() {
    serviceVid.pause()
    serviceVid2.play()
  })

  $( '.servicePlay' ).on( 'click', function() {
      // sets the source to nothing, stopping the video
      // $frame.attr( 'src','' ); 
      // sets it back to the correct link so that it reloads immediately on the next window open
      // $frame.attr( 'src', vidsrc );

      serviceVid.play()
      serviceVid2.pause()
  })
}

if ( $modal.length ) {
  // COOKIE POLICY
  if ( $modal.hasClass( 'cookie-policy' ) ) {
    $( '.close-cookie-policy , .cookie-policy .close' ).on(  'click', ( e ) => {
      e.preventDefault();
      //removes the class making the modal visable initially
      $('.cookie-policy').removeClass( 'show' ); 

      // cookie doesn't exist yet, create the cookie
      var cookie1Day = 1;

      Cookies.set(  'cookie_policy', 'true', {//'name' , 'value' pair
        expires: cookie1Day,
        secure: true //must read on an HTTPS
      });          
    });

    if ( Cookies.get( 'cookie_policy' ) == 'true' ) {
      //if cookie 'cookie_policy' exists, dont show the modal
      $('.cookie-policy').removeClass( 'show' );
    }
  }

  if ( $modal.hasClass( 'register' ) ) {
    // INSIGHTS REGISTRATION
    $( '.modal.register.cookie .close' ).on(  'click', ( e ) => {

      e.preventDefault();
      //removes the class making the modal visable initially
      $( '.modal.register.cookie' ).removeClass( 'show' ); 

      // cookie doesn't exist yet, create the cookie
      var cookie1Day = 1;

      Cookies.set( 'register_click', 'true', {//'name' , 'value' pair
        expires: cookie1Day,
        secure: true //must read on an HTTPS
      });          
    });

    $( '#modal-register-form' ).on( 'submit', () => {
      //removes the class making the modal visable initially
      $( '.modal.register.cookie' ).removeClass( 'show' ); 

      // cookie doesn't exist yet, create the cookie
      var cookie1Day = 1;

      Cookies.set( 'register_click', 'true', {//'name' , 'value' pair
        expires: cookie1Day,
        secure: true //must read on an HTTPS
      });          
    });

    if ( Cookies.get( 'register_click' ) == 'true' ) {
      //if cookie 'register_click' exists, dont show the modal
      $( '.modal.register.cookie' ).removeClass( 'show' );
    } else {
        setTimeout( () => {
          $( '.modal.register.cookie' ).addClass( 'show' );
        }, 2000);
    }
  }
}
